// Third-party imports
import $ from 'jquery';

// Local imports
import { toggle_slide } from '../util/animation.js';

// Module name
export const MODULE_NAME = 'reveal_toggle';

export let global_vars = {};
const revealClass = 'revealToggle--revealed';

export function initialize(global) {
    initClickToggler(
        global,
        '.revealToggle-mobileToggle',
        '.revealToggle-mobileHide'
    );
    initClickToggler(
        global,
        '.revealToggle-toggleCheckbox',
        '.revealToggle-hide'
    );
    initClickButton(global, '.revealToggle-toggleButton', '.revealToggle-hide');
}

function initClickButton(global, selector, hider) {
    if (selector === '.revealToggle-toggleButton') {
        eachToggleSector(global, selector, 'click', hider);
    }
}

function initClickToggler(global, selector, hider) {
    if (selector === '.revealToggle-toggleCheckbox') {
        eachToggleSector(global, selector, 'change', hider);
    } else {
        eachToggleSector(global, selector, 'click', hider);
        eachToggleSector(global, selector, 'keypress', hider);
    }
}

function eachToggleSector(global, selector, event, hider) {
    let all_sel = global.document.querySelectorAll(selector);
    for (let sel of all_sel) {
        init_toggle(sel, hider);
        togglerEventHandler(global, sel, event, hider);
    }
}

function init_toggle(el, hider, container) {
    if (container === undefined) {
        container = el.closest('.revealToggle-container');
    }

    if (!container) {
        return;
    }

    if (el.classList.contains('revealToggle-toggleCheckbox')) {
        let is_revealed = container.classList.contains(revealClass);
        if (el.checked === is_revealed) {
            return;
        }

        do_toggle(el, hider, container);
    }
}

function do_toggle(el, hider, container) {
    container.classList.toggle(revealClass);

    if (el.classList.contains('revealToggle-toggleButton')) {
        let howItWorks = $('.revealToggle-toggleButton');
        if (container.classList.contains(revealClass)) {
            howItWorks.attr('aria-expanded', 'true');
        } else {
            howItWorks.attr('aria-expanded', 'false');
        }
    }

    // Slide down if element is not visible, slide up if the element is
    // visible
    let all_hider_el = container.querySelectorAll(hider);
    for (let hider_el of all_hider_el) {
        toggle_slide(hider_el);
    }
    swapTextDataCheck(global, el, container);
}

function togglerEventHandler(global, el, event, hider) {
    el.addEventListener(event, e => {
        let cur_el = e.currentTarget;
        let container = cur_el.closest('.revealToggle-container');
        do_toggle(cur_el, hider, container);
    });
}

function swapTextDataCheck(global, thisToggler, thisContainer) {
    let textTarget;
    let mobile = global.document.querySelector('.revealToggle-mobileToggle');
    if (thisToggler === mobile) {
        textTarget = thisToggler.querySelectorAll('.js-swapText');
    } else {
        textTarget = thisToggler.parentNode.querySelectorAll('.js-swapText');
    }

    for (let t of textTarget) {
        if (t.dataset.swaptext1 && t.dataset.swaptext2) {
            swapText(t, thisContainer);
        }
    }
}

function swapText(textTarget, container) {
    let swappedText = textTarget.dataset.swaptext1;
    let initialText = textTarget.dataset.swaptext2;

    if (container.classList.contains(revealClass)) {
        textTarget.textContent = swappedText;
    } else {
        textTarget.textContent = initialText;
    }
}
